import { render, staticRenderFns } from "./MyCp3.vue?vue&type=template&id=3efd54d8&scoped=true&"
import script from "./MyCp3.vue?vue&type=script&lang=js&"
export * from "./MyCp3.vue?vue&type=script&lang=js&"
import style0 from "./MyCp3.vue?vue&type=style&index=0&id=3efd54d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efd54d8",
  null
  
)

export default component.exports